/* eslint-disable @typescript-eslint/no-explicit-any */
import { DataCard } from '@europrocurement/flexy-components';
import { FaOptionIcon, NamedIconsType } from '@europrocurement/l2d-icons';
import { Button, SxProps, type Palette } from '@mui/material';
import React, { useCallback } from 'react';
import { useAsyncStatus, useHandleError } from '@europrocurement/l2d-hooks';
import CentralDataCardStat from '../CentralDataCardStat/CentralDataCardStat';

type WidgetWithActionProps = {
    title: string | React.ReactNode;
    icon: NamedIconsType;
    actionMessage: string;
    actionCallback: () => Promise<void>;
    data?: string | number;
    paragraph?: string;
    color?: keyof Palette;
    loadingMessage?: string;
    beforeActionCallback?: () => void;
    onActionSuccessCallback?: () => void;
    onActionFailureCallback?: () => void;
    sx?: SxProps;
    sxData?: SxProps;
};

const WidgetWithAction: React.FunctionComponent<WidgetWithActionProps> = function ({
    title,
    icon,
    actionMessage,
    actionCallback,
    data = undefined,
    paragraph = undefined,
    color = 'primary',
    loadingMessage = 'Chargement de la page...',
    beforeActionCallback = () => {},
    onActionSuccessCallback = () => {},
    onActionFailureCallback = () => {},
    sx,
    sxData,
}: WidgetWithActionProps) {
    const { status, startLoading, setSuccess, setError } = useAsyncStatus();
    const { handleFailure } = useHandleError();
    const requestLists = useCallback(async () => {
        startLoading();
        await actionCallback();
    }, [actionCallback, startLoading]);

    return (
        <DataCard
            title={title}
            color={color}
            iconBgColor="transparent"
            iconColor="transparent"
            sx={{ width: '100%', height: '100%', margin: 0, ...sx }}
            sxCardContent={{ padding: 0, '&:last-child': { paddingBottom: 0 } }}
            icon={
                <FaOptionIcon
                    {...icon.props}
                    size="2x"
                    color={`${color}.main`}
                    optionColor={`${color}.dark`}
                    optionProps={{
                        ...icon.props.optionProps,
                    }}
                    iconProps={{
                        radius: 100,
                        ...icon.props.iconProps,
                    }}
                />
            }
            tools={
                <Button
                    color={color as any}
                    variant="outlined"
                    disabled={status.loading}
                    onClick={() => {
                        beforeActionCallback();

                        setTimeout(() => {
                            requestLists()
                                .then(() => {
                                    onActionSuccessCallback();

                                    setSuccess();
                                })
                                .catch((error: unknown) => {
                                    onActionFailureCallback();

                                    handleFailure({
                                        error,
                                        setError,
                                    });
                                });
                        }, 250);
                    }}
                >
                    {actionMessage}
                </Button>
            }
        >
            <CentralDataCardStat
                data={status.loading ? undefined : data}
                paragraphDetail={status.loading ? loadingMessage : paragraph}
                sx={{ color: `${color}.main`, ...sxData }}
            />
        </DataCard>
    );
};

export default WidgetWithAction;
